import React, { useCallback, useState } from 'react'
import { AppImg, FormattedHTMLMessage, Button } from '@web/walter-ui-kit'

import { GetProductsReturn } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import KycModal from './KycModal'
import { images } from '~constants/images'
import { CardsViews } from '~pages/CardsPage/types'
import { cardsApi, useProducts } from '~api'
import { usePromise } from '~hooks/usePromise'

interface Props {
    setView: (newView: CardsViews) => void
}

function NoCards({ setView }: Props) {
    const [isKycOpen, setIsKycOpen] = useState(false)

    const { isLoading: isProductsLoading, mutate } = useProducts()

    const { send: onGetCardClick, isLoading: isFetchProductsLoading } = usePromise(async () => {
        let productsData: GetProductsReturn | undefined
        await mutate(
            async () => {
                productsData = await cardsApi.getProducts()
                return productsData
            },
            { revalidate: false }
        )

        if (!productsData || productsData?.products.length <= 0) {
            setIsKycOpen(true)
        } else {
            setView(CardsViews.NewCards)
        }
    })

    const onKycClose = useCallback(() => {
        setIsKycOpen(false)
    }, [])

    return (
        <>
            <KycModal isOpen={isKycOpen} onClose={onKycClose} />
            <div className={s.wrap}>
                <div className={s.content}>
                    <AppImg imgName={images.cards} themed={false} path="common" className={s.img} />
                    <FormattedHTMLMessage className={s.title} {...lang.title} />
                    <FormattedHTMLMessage className={s.text} {...lang.text} />
                    <div className={s.button}>
                        <Button
                            mode="primary"
                            size="l"
                            dataPointer="get_cards"
                            onClick={onGetCardClick}
                            isLoading={isProductsLoading || isFetchProductsLoading}
                            fullWidth
                        >
                            <FormattedHTMLMessage {...lang.button} />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NoCards
